import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { receiptSubTypes, receiptTypes } from 'editor/game_purchaseReward/utils/invoiceType';
import VerifyStatusLabel from 'client/game_photoUpload/PhotoUpload/VerifyStatusLabel';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import { gameTypes } from 'config/promoGameTypes';

export default function ResultInfoList({ result = {}, validStatus, gameType }) {
    const themeStyle = usePromoSettingThemeStyle();

    const title = (() => {
        const { receiptType, receiptSubtype, receiptNumber = '' } = result;
        const upperCaseReceiptNumber = String(receiptNumber).toUpperCase();

        switch (gameType) {
            case gameTypes.PURCHASE_REWARD:
                let type = '';
                switch (Number(receiptType)) {
                    case receiptTypes.EINVOICE:
                        type = i18n.t(
                            receiptSubtype === receiptSubTypes.CARRIER
                                ? 'label.result.title.einvoice_carrier'
                                : 'label.result.title.einvoice'
                        );
                        break;
                    case receiptTypes.INVOICE:
                        type = i18n.t('label.result.title.invoice');
                        break;
                    case receiptTypes.RECEIPT:
                        type = i18n.t('label.result.title.receipt');
                        break;
                    default:
                        break;
                }
                return `${type} - ${upperCaseReceiptNumber}`;
            case gameTypes.ORDER_REWARD:
                return `${i18n.t('label.result.title.order_number')}：${upperCaseReceiptNumber}`;
            default:
                break;
        }
    })();

    return (
        <>
            <div css={wrapperStyle}>
                <Typography variant="subtitle1" css={titleWrapperStyle(themeStyle.titleColor)}>
                    {title}
                </Typography>
                <div css={statusStyle}>
                    <VerifyStatusLabel status={validStatus} />
                </div>
            </div>
            <Divider css={dividerStyle} />
        </>
    );
}

const wrapperStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const titleWrapperStyle = color => css`
    margin-top: 16px;
    color: ${color};
`;

const statusStyle = css`
    max-width: 89px;
    margin-top: 20px;
`;

const dividerStyle = css`
    margin: 16px -6px;
`;
